module.exports = __webpack_public_path__ + "img/zhanli-drop2.4ad1d129.png";